export enum QueriesKeys {
  auth = 'auth',
  bundles = 'bundles',
  bundleOffers = 'bundleOffers',
  fastBundleOffers = 'fastBundleOffers',
  categories = 'categories',
  crypto = 'crypto',
  games = 'games',
  gameById = 'gameById',
  gamesSimilar = 'gamesSimilar',
  kyc = 'kyc',
  orders = 'orders',
  withdrawals = 'withdrawals',
  paymentTransaction = 'paymentTransaction',
  types = 'types',
  user = 'user',
  wallet = 'wallet',
  transactions = 'transactions',
  providers = 'providers',
  provider = 'provider',
  media = 'media',
  /** @deprecated use `usersBanners` */
  banners = 'banners',
  usersBanners = 'usersBanners',
  allPublicBanners = 'allPublicBanners',
  /** @deprecated use `allPublicBanners` */
  defaultBanner = 'defaultBanner',
  withdrawLimit = 'withdrawLimit',
  withdrawMonthlyLimit = 'withdrawMonthlyLimit',
  withdrawConfig = 'withdrawConfig',
  rewardsGrouped = 'rewardsGrouped',
  paymentMethods = 'paymentMethods',
  systemPage = 'systemPage',
  gamesWithWins = 'gamesWithWins',
  gamesWithWinsInfinite = 'gamesWithWinsInfinite',
  gameProviderRtp = 'gameProviderRtp',
  roundsWithWins = 'roundsWithWins',
  gameLastWin = 'gameLastWin',
  gameUserRtp = 'gameUserRtp',
  systemPages = 'systemPages',
  activeDepositLimit = 'activeDepositLimit',
  verifications = 'verifications',
  reviews = 'reviews',
  gameReviews = 'gameReviews',
  author = 'author',
  sharedRound = 'sharedRound',
  meFastOffers = 'meFastOffers',
  meReferral = 'meReferral',
  meReferees = 'meReferees',
  meRefereesSummary = 'meRefereesSummary',
  meRefereesAvailableRewardsCount = 'meRefereesAvailableRewardsCount',

  // gamification = 'gamification',
  mePlayerProfile = 'mePlayerProfile',
  progressStatuses = 'progressStatuses',
  levelUpRewards = 'levelUpRewards',
  mePlayerQuests = 'mePlayerQuests',
  mePlayerStreak = 'mePlayerStreak',
  streakXpAwards = 'streakXpAwards',
  mePlayerGamificationRewards = 'mePlayerRewards',
  mePlayerGamificationGroupedRewards = 'mePlayerGroupedRewards',
}
